<template>
	<div class="form__login">
		<div class="form__login__fields">
			<div
				v-if="buscandoUsuario"
				class="form__login____user__info"
			>
				<Loading />
				<label>{{ $t('buscandoUsuario') }}</label>
			</div>
			<div
				v-else
				class="form__login____user__info"
			>
				<img
					:src="imagemUsuario"
					style="border-radius: 50%"
				/>
				<label class="form__login____user__info__name">{{ nome }}</label>
				<label class="form__login____user__info__email">{{ email }}</label>
			</div>

			<InputPassword
				id="txt_senha"
				v-model="model.password"
				class="form__login__fields__item"
				:label="$t('typeYourNewPassword')"
			/>
			<InputPassword
				id="txt_senha"
				v-model="model.confirmaPassword"
				class="form__login__fields__item"
				:label="$t('typeYourNewPasswordAgain')"
			/>

			<div
				style="
					padding: 0.5rem;
					border-radius: 5px;
					justify-content: center;
					align-items: center;
					display: flex;
					flex-direction: column;
				"
			>
				<label style="font-weight: 600; margin-bottom: 1rem"
					><i
						class="fas fa-shield-alt"
						style="color: rgb(var(--color-default))"
					/>
					Senhas fortes incluem:</label
				>
				<p
					style="margin-bottom: 5px"
					:class="{ 'correct-requirement': passwordHasLower }"
				>
					<i
						v-show="passwordHasLower"
						class="fas fa-check correct-requirement"
					/>
					{{ $t('passwordHasToHaveLowerLetter') }}
				</p>
				<p
					style="margin-bottom: 5px"
					:class="{ 'correct-requirement': passwordHasUpper }"
				>
					<i
						v-show="passwordHasUpper"
						class="fas fa-check correct-requirement"
					/>
					{{ $t('passwordHasToHaveUpperLetter') }}
				</p>
				<p
					style="margin-bottom: 5px"
					:class="{ 'correct-requirement': passwordHasDigit }"
				>
					<i
						v-show="passwordHasDigit"
						class="fas fa-check correct-requirement"
					/>
					{{ $t('passwordHasToHaveDigit') }}
				</p>
				<p
					style="margin-bottom: 5px"
					:class="{ 'correct-requirement': passwordHasSpecials }"
				>
					<i
						v-show="passwordHasSpecials"
						class="fas fa-check correct-requirement"
					/>
					{{ $t('passwordHasToHaveSpecials') + ' ' + specials.split('').join(' ') + '' }}
				</p>
				<p
					style="margin-bottom: 5px"
					:class="{ 'correct-requirement': passwordHasLength }"
				>
					<i
						v-show="passwordHasLength"
						class="fas fa-check correct-requirement"
					/>
					{{ $t('passwordHasToHaveAtLeastLength', { x: length }) }}
				</p>
				<p
					style="margin-bottom: 5px"
					:class="{ 'correct-requirement': model.password && !passwordHasNotWhitespaces }"
				>
					<i
						v-show="model.password && !passwordHasNotWhitespaces"
						class="fas fa-check correct-requirement"
					/>
					{{ $t('passwordHasToHaveNoWhitespaces') }}
				</p>
				<p
					v-show="isPasswordValid"
					style="margin-bottom: 5px"
					:class="{ 'correct-requirement': model.password === model.confirmaPassword }"
				>
					<i
						v-show="model.password === model.confirmaPassword"
						class="fas fa-check correct-requirement"
					/>
					{{ $t('passwordsMustMatch') }}
				</p>
			</div>

			<Button
				semantic-class="mini"
				:label="$t('send')"
				:loading="isLoading"
				:disabled="!isPasswordValid || model.password != model.confirmaPassword"
				@click="atualizarSenhaDoUsuario"
			/>
		</div>
	</div>
</template>

<script>
import { mapMutations } from 'vuex'

import {
	buscarDadosParaTelaDeRecuperacaoDeSenha,
	redefinirSenha,
} from '../../../services/requests/AccountRequests'

import Button from '../../../components/Button/Button'
import InputPassword from '../../../components/InputPassword/InputPassword'
import Loading from '../../../components/Loading/Loading'

import useMagicRegExp from '../../../mixins/useMagicRegExp'

export default {
	components: { Button, InputPassword, Loading },
	mixins: [useMagicRegExp],
	props: {
		idDoUsuario: {
			type: String,
			require: true,
		},
		tokenParaRedefinirSenha: {
			type: String,
			require: true,
		},
	},
	data() {
		return {
			nome: '',
			email: '',
			userImage: '',
			isLoading: false,
			buscandoUsuario: true,
			model: {
				password: '',
				confirmaPassword: '',
			},
		}
	},
	computed: {
		imagemUsuario() {
			return this.userImage !== '' && this.userImage != undefined
				? this.userImage
				: `https://ui-avatars.com/api/?name=${this.email}&background=74962c&color=b2c983`
		},
		passwordHasUpper() {
			return this.model.password ? this.checkForUppercase(this.model.password) : null
		},
		passwordHasLower() {
			return this.model.password ? this.checkForLowercase(this.model.password) : null
		},
		passwordHasDigit() {
			return this.model.password ? this.checkForDigit(this.model.password) : null
		},
		passwordHasSpecials() {
			return this.model.password ? this.checkForSpecial(this.model.password) : null
		},
		passwordHasLength() {
			return this.model.password ? this.checkForLength(this.model.password) : null
		},
		passwordHasNotWhitespaces() {
			return this.model.password ? this.checkForWhitespaces(this.model.password) : null
		},
		isPasswordValid() {
			return this.model.password ? this.passwordIsValid(this.model.password) : null
		},
	},
	methods: {
		...mapMutations('moduleMessages', ['mutationShowMessage']),

		atualizarSenhaDoUsuario() {
			this.isLoading = true
			var body = {
				email: this.email,
				senha: this.model.password,
				senhaConfirmada: this.model.confirmaPassword,
				tokenParaResetarSenha: this.tokenParaRedefinirSenha,
			}

			redefinirSenha(body)
				.then((response) => {
					if (response.status == 200) {
						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageText: response.data,
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})

						this.$router.push({ name: 'login' })
					} else {
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageText: response.data,
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					}
					this.isLoading = false
				})
				.catch((err) => {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: err.response.data,
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
					this.isLoading = false
				})
		},
	},
	created() {
		buscarDadosParaTelaDeRecuperacaoDeSenha(this.idDoUsuario).then((response) => {
			this.nome = response.data.nome
			this.email = response.data.email
			this.userImage = response.data.userImage
			this.buscandoUsuario = false
		})
	},
}
</script>

<style scoped>
.form__login {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
}

.form__login__fields {
	display: flex;
	flex-direction: column;
	padding-top: 3.21rem;
	width: 100%;
	justify-content: space-between;
}

.form__login____user__info {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	margin-bottom: 1rem;
}

.form__login____user__info__name {
	font-size: 1rem;
	font-weight: 600;
}

.form__login____user__info__email {
	font-size: 0.8rem;
	font-weight: 100;
}

.form__login__message {
	font-size: 1rem;
	color: var(--color-navy-blue);
	font-weight: bold;
	text-align: center;
}

p {
	font-size: 0.75rem;
}

.correct-requirement {
	color: var(--color-success-background);
	font-weight: bold;
}
</style>
